module.exports = __webpack_public_path__ + "img/Set-Email-and-phone.f3a9f1e5.png";